module.exports = __webpack_public_path__ + "img/qualite_acaplast_05.188224d9.jpg";